import { useEffect, useState } from 'react';

type Color = string;

const isCustomProperty = (color: Color) => {
  return color?.startsWith('var(');
};

const getCustomPropertyValue = (color: string) => {
  // splits color into an array. For a ZDS color, it would look like this:
  // ["var", "--zds-colors-error400", "#ce482d", ""]
  // for a different custom property without a fallback, it might look like this:
  // ["var", "--colors-error400", ""]
  // If there is a fallback color provided, then it will return the fallback color if it can't access the custom property.
  // Otherwise it will return #ffffff/white;
  const maybeColorArray = color.split(/[\s, (\s )]+/);
  const maybeColor = Array.isArray(maybeColorArray)
    ? maybeColorArray[1]
    : color;
  const computedStyle = getComputedStyle(
    document.documentElement
  ).getPropertyValue(maybeColor);

  // check if there is a fallbackColor provided. If not, default to white.
  const fallbackColor =
    maybeColorArray.length === 4 ? maybeColorArray[2] : '#ffffff';
  return computedStyle.length > 0 ? computedStyle : fallbackColor;
};

const getColor = (color: Color) => {
  return color && isCustomProperty(color)
    ? getCustomPropertyValue(color)
    : color;
};

/**useZds
 * Gets the hex value of a zds custom property
 */
export const useZdsColor = (color: string) => {
  const [transformedColor, setTransformedColor] = useState(color);
  useEffect(() => {
    setTransformedColor(getColor(color));
  }, [color]);
  return transformedColor;
};
